import React, { useEffect, useRef, useState } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { Await, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { AddItemsInStudBill, fetchStudentSaleData, fetchStockItemSize } from '../../Store/PHPSlice/stockApi';
import { selectStudentSaleData, selectStockItems } from '../Selectors/Master/OutwardSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchStockItemlist } from '../../Store/PHPSlice/StkInw';
import axios from 'axios';
import { insertAdminSaleEntry } from '../../Store/PHPSlice/stockApi';
import { Checkbox } from '@mui/material';

const StudentSaleAdd = () => {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [selectedRows, setSelectedRows] = useState(new Set());
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        ID: '',
        balamt: '',
        billNo: '',
        cgst: '',
        discnt_amt: '0',
        discnt_type: '',
        discnt_val: '0',
        dt: '',
        freight_ch: '0',
        gst: '',
        gst_val: '',
        igst: '',
        netamt: '',
        other_ch: '0',
        schlId: '',
        schlNm: '',
        sgst: '',
        totamt: '0',
        totissqty: '0',
        zoneId: '',
        zoneNm: '',
        firmId: '',
        firmNm: '',
        adrs: '',
        schladrs: "",
        firmph: '',
        fgst: '',
        schlph: '',
        totrate: '',
        sgstper: '',
        cgstper: '',
        igstper: '',
        schlcd: '',
        bankNm: '',
        ifsc: '',
        ac_no: '',
        add: '',
        branchNm: '',
        item: '',
        newtotqty: '0',
        newtotamt: '0'
    });
    const [newData, setNewData] = useState({
        adsid: Id,
        totqty: '0',
        totamt: '0',
        netamt: '0',
        igst: '0',
        cgst: '0',
        sgst: '0',
        discnt_amt: '0',
        totsrate: '0',
        userId: userdata?.ID
    });

    const [packInfo, setPackInfo] = useState([]);
    const [selectFirmdata, setSelectFirmdata] = useState({});
    const [multiItems, setMultiItems] = useState([]);

    const packData = useSelector(selectStudentSaleData);
    const firmlist = useSelector(selectFirm);
    const stkdata = useSelector(selectStockItems);
    const [tableData, setTableData] = useState([]);

    const [newAdd, setNewAdd] = useState([]);
    // console.log(packData)
    useEffect(() => {
        dispatch(fetchStudentSaleData(Id));
        dispatch(fetchCompanyData());
        dispatch(fetchStockItemlist());

    }, [Id, dispatch]);

    useEffect(() => {
        if (packData?.data) {
            const item = packData?.data;
            const {
                ID,
                balamt,
                billNo,
                cgst,
                discnt_amt,
                discnt_type,
                discnt_val,
                dt,
                DT,
                freight_ch,
                gst,
                gst_val,
                igst,
                netamt,
                other_ch,
                schlId,
                schlNm,
                studNm,
                sgst,
                totamt,
                totissqty,
                zoneId,
                zoneNm,
                firmId,
                firmNm,
                fadrs,
                schladrs,
                firmgst,
                firmph,
                schlph,
                schlcd,
                bankNm,
                ifsc,
                ac_no,
                branchNm,
            } = item;
            const firmdata = firmlist?.data?.find(item => item.ID === firmId);
            setSelectFirmdata(firmdata);
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
            let sgstper, igstper, cgstper;
            if (igst === '0') {
                sgstper = (parseFloat(gst_val) / 2);
                cgstper = (parseFloat(gst_val) / 2);
                igstper = 0;
            } else {
                igstper = gst;
                sgstper = 0;
                cgstper = 0;
            }
            setFormData(prev => ({
                ...prev,
                ID: ID,
                balamt: balamt,
                billNo: billNo,
                cgst: cgst,
                discnt_amt: discnt_amt,
                discnt_type: discnt_type,
                discnt_val: discnt_val,
                dt: DT,
                freight_ch: freight_ch,
                fgst: firmgst,
                gst: gst,
                gst_val: gst_val,
                igst: igst,
                netamt: netamt,
                other_ch: other_ch,
                schlId: schlId,
                schlNm: schlNm,
                studNm:studNm,
                sgst: sgst,
                totamt: totamt,
                totissqty: totissqty,
                zoneId: zoneId,
                zoneNm: zoneNm,
                firmId: firmId,
                firmNm: firmNm,
                adrs: fadrs,
                schladrs: schladrs,
                schlph: schlph,
                firmph: firmph,
                totrate: totrate,
                igstper: igstper,
                sgstper: sgstper,
                cgstper: cgstper,
                schlcd: schlcd,
                bankNm: bankNm,
                ac_no: ac_no,
                ifsc: ifsc,
                branchNm: branchNm
            }));

            setNewData(prev => ({
                ...prev,
                totamt: totamt,
                totqty: totissqty,
                totsrate: totrate,
                igst: igst,
                cgst: cgst,
                sgst: sgst,
                discnt_amt: discnt_amt,
                netamt: netamt
            }));
        }
        if (packData?.info && packData.info2?.length > 0) {
            const info = packData.info2;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);

            setPackInfo(info);
        }
    }, [packData]);


    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    }

    const dropdownOrdType = [
        {
            label: 'Item',
            id: 'item',
            options: stkdata?.data?.filter(item => !multiItems.some(val => val.itemId === item.ID)) || [],
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },


    ];

    const fetchItemlistStkInw = async (id) => {
        const { stkId, itemId } = id;
        try {
            // const response = await axios.get(`${baseUrl}?apicall=getStkDataItemWise&stkId=${stkId}&itemId=${itemId}`);
            const response = await axios.get(`${baseUrl}?apicall=getStockInwMergeItemWithSizes&itemId=${itemId}`);

            // console.log(response?.data);
            setTableData(response?.data?.info);
            const datas = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
            setFormData(prev => ({
                ...prev,
                totqty: parseFloat(prev.totqty) + parseFloat(datas || 0),
                totqty2: parseFloat(datas || 0),
                state_type: datas?.state_type
            }));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'item':
                if (value) {
                    const selectitem = stkdata?.data?.filter((val) => val.ID === value);
                    // console.log(selectitem)
                    const data = {
                        stkId: selectitem?.map(val => val.id),
                        itemId: value
                    };
                    // console.log(data)
                    fetchItemlistStkInw(data);
                };
                break;


            default:
                break;
        }
    };


    // Example usage:
    // console.log(numberToWords(123)); // Output: "One Hundred Twenty Three"
    // console.log(numberToWords(1234567)); // Output: "One Million Two Hundred Thirty Four Thousand Five Hundred Sixty Seven"
    // console.log(packInfo);

    // console.log(selectFirmdata);


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };



    const handleChange = (index, field, value) => {
        const filterData = tableData?.filter(item => item.bqty !== '0');
        const updatedData = [...filterData];

        if (field === 'qty') {
            const prevQty = parseFloat(updatedData[index][field] || 0);
            const newQty = parseFloat(value || 0);

            // Update the quantity first
            updatedData[index][field] = newQty;
            setTableData(updatedData);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totQty: parseFloat(prev.totQty) - prevQty + newQty
            }));
        }

        if (field === 'prate') {
            const prevPrate = parseFloat(updatedData[index][field] || 0);
            const newPrate = parseFloat(value || 0);

            // Update the quantity first
            updatedData[index][field] = newPrate;
            setTableData(updatedData);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totprate: parseFloat(prev.totprate) - prevPrate + newPrate
            }));
        }

        if (field === 'srate') {
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const newQSrate = parseFloat(value || 0);

            // Update the quantity first
            updatedData[index][field] = newQSrate;
            setTableData(updatedData);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totsrate: parseFloat(prev.totsrate) - prevSrate + newQSrate
            }));
        }

        if (field === 'color') {
            updatedData[index][field] = value;
            setTableData(updatedData);
        }
        if (field === 'issqty') {
            const enteredQty = parseFloat(value || 0);
            const availableQty = parseFloat(updatedData[index].bqty || 0);
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const disrate = parseFloat(updatedData[index].srate || 0);
            if (enteredQty > availableQty) {
                alert("Issued quantity cannot be greater than available quantity (bqty).");
                return; // Don't update the state
            }
            const samt = disrate * enteredQty;
            const balqty = availableQty - enteredQty;
            updatedData[index][field] = enteredQty;
            updatedData[index].saleamt = samt;
            updatedData[index].balqty = balqty;
            setTableData(updatedData);
            const totissqty = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
            const prevIss = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totIssqty), 0);
            const totamt = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.saleamt), 0);
            // Update the total quantity
            // setFormData(prev => ({
            //     ...prev,
            //     newtotqty: parseFloat(prev.newtotqty) + totissqty,
            //     newtotamt: parseFloat(prev.newtotamt) + totamt,
            // }));
        }

    };

    const handleMultiItems = () => {

        const filteredItems = tableData.filter(item => Number(item.issqty) > 0);

        const totqty = filteredItems?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0) + parseFloat(formData.newtotqty);
        const totamt = filteredItems?.reduce((acc, sum) => acc + parseFloat(sum.saleamt), 0) + parseFloat(formData.newtotamt);
        // console.log(totqty, totamt);
        setNewAdd(prev => [...prev, ...filteredItems]);
        setTableData([]);
        setFormData(prev => ({
            ...prev,
            item: '',
            newtotamt: totamt,
            newtotqty: totqty
        }));

        //new updated totqty and totamt , gstvalues discount etc...
        const totrate = filteredItems?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
        const new_totamt = parseFloat(formData.totamt) + totamt;
        const new_totqty = parseFloat(formData.totissqty) + totqty;
        // console.log(new_totqty);
        const new_rate = parseFloat(formData.totrate) + parseFloat(totrate);

        const discnt_amt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(new_totamt));

        const netamt = parseFloat(new_totamt) - parseFloat(discnt_amt) + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch)

        let igst, cgst, sgst = 0;
        let gstvals = Math.round()
        if (formData.igst !== '0') {

        }
        setNewData(prev => ({
            ...prev,
            totamt: new_totamt,
            totqty: new_totqty,
            totsrate: new_rate,
            discnt_amt: discnt_amt,
            netamt: netamt
        }));

    };


    function convertIntoOneObject(newData, newAdd) {

        const data = {

            totamt: newData.totamt,
            discnt_amt: newData.discnt_amt,
            igst: newData.igst,
            cgst: newData.cgst,
            sgst: newData.sgst,
            netamt: newData.netamt,
            totqty: newData.totqty,
            userId: newData.userId,
            newAdd: newAdd,
            adsaleId: newData.adsid
        };
        return data;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const postObj = convertIntoOneObject(newData, newAdd);
        // console.log(postObj);

        dispatch(AddItemsInStudBill(postObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Student Sale New Item Details Added Successfully......!!!");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };


    // Checkbox toggle for selecting/deselecting a row
    const handleCheckboxChange = (index) => {
        setSelectedRows((prevSelected) => {
            const updated = new Set(prevSelected);
            if (updated.has(index)) {
                updated.delete(index);
            } else {
                updated.add(index);
            }
            return updated;
        });
    };

    // Delete all selected rows
    const handleRemoveSelected = () => {
        const updatedData = newAdd?.filter((_, index) => !selectedRows.has(index));
        const totqty = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
        const totamt = updatedData?.reduce((acc, sum) => acc + parseFloat(sum.saleamt), 0);
        setNewAdd((prevData) => prevData.filter((_, index) => !selectedRows.has(index)));
        setFormData(prev => ({
            ...prev,
            newtotamt: totamt,
            newtotqty: totqty
        }));
        setSelectedRows(new Set()); // Clear selection after deletion
    };


    // const handleCheckboxChange = (index) => {
    //     setSelectedRows(prevSelectedRows => {
    //         const newSelectedRows = new Set(prevSelectedRows);
    //         if (newSelectedRows.has(index)) {
    //             newSelectedRows.delete(index);
    //         } else {
    //             newSelectedRows.add(index);
    //         }
    //         return newSelectedRows;
    //     });
    // };

    // const handleRemoveSelected = () => {
    //     setMultiItems(prevFormArray =>
    //         prevFormArray.filter((_, index) => !selectedRows.has(index))
    //     );
    //     setSelectedRows(new Set()); // Clear selection after removal
    // };

    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    <h3 className="heading">Admin Student Sale Invoice </h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{formData.firmNm}(Ref.Admin)</h2>
                                        <b>Add.:</b>{formData.adrs}
                                        <br />
                                        <b>Contact:</b>{formData.firmph} <br />
                                        <b>GST No.:</b> {formData.fgst}
                                    </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3>
                                        <b>Student Name:</b><b style={{ color: 'blue' }}>{formData.studNm} </b> <br />
                                        <b>School Name:</b><b style={{ color: 'blue' }}>{formData.schlNm}</b> <br />
                                        <b>Code:</b><b style={{ color: 'blue' }}>{formData.schlcd} </b> <br />
                                        {/* <b>Add:</b> <span style={{ color: 'blue' }}>{formData.schladrs}</span> */}
                                        <b>Add:</b> <span style={{ color: 'blue' }}>-</span>
                                        <br />
                                        {/* <b>Contact:</b> <span style={{ color: 'blue' }}>{formData.schlph}</span> */}
                                        <b>Contact:</b> <span style={{ color: 'blue' }}></span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Bill No:</td>
                                    <td><b>{formData.billNo}</b></td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{formData.dt}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{formData.trspt}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{formData.remark}</td>
                                </tr>
                                <tr>
                                    <td>No. of Cartoons:</td>
                                    <td>{formData.parcelqty}</td>
                                </tr>
                                <tr>
                                    <td>Ship To:</td>
                                    <td>{formData.shtoNm}</td>
                                </tr>
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{formData.shtoadrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <h3>Previous Items</h3>
                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.srate}</td>
                                        <td>{item.amt}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totissqty}</b></td>
                                    <td><b></b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'row', margin: '2%' }}>


                        {
                            dropdownOrdType?.map((drop) => (
                                <Dropdown
                                    key={drop.label}
                                    label={drop.label}
                                    id={drop.id}
                                    options={drop.options}
                                    value={drop.value}
                                    onChange={drop.onChange}
                                    getOptionLabel={drop.getOptionLabel}
                                    isOptionEqualToValue={drop.isOptionEqualToValue}
                                    valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                    color={drop.color}
                                />
                            ))
                        }

                        <Grid item xs={12} md={6}>

                            <Button variant="contained" color="primary" onClick={handleRemoveSelected}>Delete</Button>
                        </Grid>

                    </Grid>






                    {Array.isArray(tableData) && tableData.length > 0 &&
                        <>
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableBody>

                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>

                                            {tableData?.filter(item => item.bqty !== "0")
                                                ?.map((item, index) => (
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.size}</TableCell>
                                                ))}

                                        </TableRow>

                                        {/* <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Color</TableCell>
                                                        {tableData?.filter(item => item.bqty !== "0")
                                                            ?.map((item, index) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                    {item.color}
                                                                </TableCell>
                                                            ))}
                                                    </TableRow> */}

                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Stock Qty</TableCell>

                                            {tableData?.filter(item => item.bqty !== "0")
                                                ?.map((item, index) => (
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                        {item.bqty}
                                                    </TableCell>
                                                ))}

                                        </TableRow>

                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Issue Qty</TableCell>

                                            {tableData?.filter(item => item.bqty !== "0")
                                                ?.map((item, index) => (
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                        <input type="text"
                                                            value={item.issqty || ''}
                                                            name='issqty'
                                                            onChange={(e) => handleChange(index, 'issqty', e.target.value)}
                                                            style={{ height: '25px', width: '60px' }}
                                                        />
                                                    </TableCell>
                                                ))}

                                        </TableRow>
                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bal Qty.</TableCell>

                                            {tableData?.filter(item => item.bqty !== "0")
                                                ?.map((item, index) => (
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                        {item.balqty}
                                                    </TableCell>
                                                ))}

                                        </TableRow>
                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Purchase Price</TableCell>

                                            {tableData?.map((item, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                    {item.prate}
                                                </TableCell>
                                            ))}

                                        </TableRow>
                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sale Price</TableCell>

                                            {tableData?.filter(item => item.bqty !== "0")
                                                ?.map((item, index) => (
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                        {item.srate}
                                                    </TableCell>
                                                ))}

                                        </TableRow>
                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Discount Sale Price</TableCell>

                                            {tableData?.filter(item => item.bqty !== "0")
                                                ?.map((item, index) => (
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                        {item.disrate}
                                                    </TableCell>
                                                ))}

                                        </TableRow>

                                        <TableRow>

                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Amt</TableCell>

                                            {tableData
                                                ?.filter(item => item.bqty !== "0")
                                                ?.map((item, index) => (
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                        {item.saleamt}
                                                    </TableCell>
                                                ))}

                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>


                            <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                <Button variant="contained" color="primary" onClick={handleMultiItems}>Add</Button>

                            </Grid>
                        </>
                    }



                    {newAdd?.length > 0 &&
                        <>
                            <h3>New Items</h3>
                            <table className="main-table">
                                <thead>
                                    <tr>
                                        <th>Select</th>
                                        <th>SR NO.</th>
                                        <th>PARTICULARS</th>
                                        <th>SIZE</th>
                                        <th>QTY</th>
                                        <th>RATE</th>
                                        <th>AMOUNT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {newAdd?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <Checkbox
                                                    checked={selectedRows.has(index)}
                                                    onChange={() => handleCheckboxChange(index)}
                                                />
                                            </td>
                                            <td>{index + 1}</td>
                                            <td>{item.itemNm}</td>
                                            <td>{item.size}</td>
                                            <td>{item.issqty}</td>
                                            <td>{item.srate}</td>
                                            <td>{item.saleamt}</td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td><b>Total</b></td>
                                        <td><b>{formData.newtotqty}</b></td>
                                        <td><b></b></td>
                                        <td><b>{formData.newtotamt}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }

                    {/* Footer */}
                    <div className="flex-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>AMOUNT IN WORDS:
                                        <b>{numberToWords(parseFloat(newData.netamt))}</b>
                                    </td>


                                </tr>
                                <tr>
                                    <td>TOTAL QTY: <b> {newData?.totqty}</b></td>
                                </tr>


                                <tr>
                                    <td>Bank Name: <b> {formData?.bankNm}</b></td>



                                </tr>
                                <tr>
                                    <td>Account No.: <b> {formData?.ac_no}</b></td>
                                </tr>

                                <tr>
                                    <td>IFSC code: <b> {formData?.ifsc}</b></td>
                                </tr>

                                <tr>
                                    <td>Branch Name: <b> {formData?.branchNm}</b></td>
                                </tr>

                            </tbody>
                        </table>

                        <table>

                            <tbody>

                                <tr>
                                    <td><b>SUB TOTAL :</b></td>
                                    <td><b>{newData.totamt}</b></td>
                                </tr>
                                <tr>
                                    <td><b>DISCOUNT AMOUNT ({formData.discnt_val}{formData.discnt_type}) :</b></td>
                                    <td><b>{newData?.discnt_amt}</b></td>
                                </tr>
                                <tr>

                                    <td><b>CGST({formData.cgstper}%)</b></td>
                                    <td>
                                        <b>{formData.cgst}</b>
                                    </td>
                                </tr>
                                <tr>

                                    <td><b>SGST({formData.sgstper}%)</b></td>
                                    <td>
                                        <b>{formData.sgst}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>IGST({formData.igstper}%)</b></td>
                                    <td>
                                        <b>{formData.igst}</b>
                                    </td>
                                </tr>


                                <tr>

                                    <td><b style={{ color: 'red' }}>FREIGHT</b></td>
                                    <td>
                                        <b style={{ color: 'red' }}>{formData.freight_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>OTHERS</b></td>
                                    <td>
                                        <b>{formData.other_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b style={{ color: 'blue' }}>GRAND TOTAL</b></td>
                                    <td>
                                        <b style={{ color: 'blue' }}>{newData.netamt}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <Grid item xs={12} textAlign="center">
                        <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                    </Grid>
                </div>

                {/* <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div> */}
            </Paper>
        </Grid>
    );
};

export default StudentSaleAdd;
